var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-form-group',{attrs:{"id":_vm.this_id,"form-state":_vm.formState,"label":_vm.label,"message":_vm.errorMessages,"nolabel":_vm.nolabel,"type":{ 'is-danger': _vm.hasError }}},[_c('BFormSelect',{attrs:{"disabled":_vm._is_readonly,"options":_vm.options,"value":_vm.selected_id},on:{"change":_vm.change}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }